
<template>
  <div id="app">
    <div>

      <div id="pageZero" class="pageZero" ref="pageZero"
        :style="{ width: '100%', height: 'auto', display: 'flex', flexDirection: 'column' }">

        <div style="position: fixed;z-index: 100;width: 100%;">
          <div class="pnavigation">
            <img src="./assets/img/logo.png" class="plogo" />
            <div :class="{ selectTitle: isSelect(1), unSelectTitle: isUnSelect(1), marginLeft240: true }"
              @click="changeTabStatus(1)">
              首页
            </div>
            <div :class="{ selectTitle: isSelect(2), unSelectTitle: isUnSelect(2), marginLeft68: true }"
              @click="changeTabStatus(2)">
              产品及解决方案
            </div>
            <div :class="{ selectTitle: isSelect(3), unSelectTitle: isUnSelect(3), marginLeft68: true }"
              @click="changeTabStatus(3)">
              服务与支持
            </div>
            <div :class="{ selectTitle: isSelect(4), unSelectTitle: isUnSelect(4), marginLeft68: true }"
              @click="changeTabStatus(4)">
              关于美奇
            </div>
            <div :class="{ selectTitle: isSelect(5), unSelectTitle: isUnSelect(5), marginLeft68: true }"
              @click="showReport()" >
              会员中心
            </div>

            
          </div>
          <div style="width: 100%;height: 1px;background-color: #e8e8e8;">

          </div>
        </div>


        <div class="pnavigation" ref="pnavigation">
          <img src="./assets/img/logo.png" class="plogo" />
          <div :class="{ selectTitle: isSelect(1), unSelectTitle: isUnSelect(1), marginLeft240: true }"
            @click="changeTabStatus(1)">
            首页
          </div>
          <div :class="{ selectTitle: isSelect(2), unSelectTitle: isUnSelect(2), marginLeft68: true }"
            @click="changeTabStatus(2)">
            产品及解决方案
          </div>
          <div :class="{ selectTitle: isSelect(3), unSelectTitle: isUnSelect(3), marginLeft68: true }"
            @click="changeTabStatus(3)">
            服务与支持
          </div>
          <div :class="{ selectTitle: isSelect(4), unSelectTitle: isUnSelect(4), marginLeft68: true }"
            @click="changeTabStatus(4)">
            关于美奇
          </div>
          <div :class="{ selectTitle: isSelect(5), unSelectTitle: isUnSelect(5), marginLeft68: true }"
            @click="showReport()">
            会员中心
          </div>
        </div>


      </div>

      <div v-if="tabStatus == 1">
        <div class="pswiper">

          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg1.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg2.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg3.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg4.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>

       
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

        <div class="padding1" :style="{ width: '100%', height: fullHeight, display: 'flex' }" id="pageOne"
          ref="pageOne">
          <div ref="mmm">
            <div style="display: flex;">
              <div class="width534">
                <div class="title36">
                  湖州美奇医疗器械有限公司
                </div>
                <div class="px31">
                  SINCE2009
                </div>
                <div class="content1">
                  湖州美奇医疗器械有限公司成立于2009年9月，总部位于浙江湖州，已获国家级高新技术企业和中国浙江省高新技术企业研究开发中心。是国家重点研发项目“糖脂代谢异常亚健康状态预警及系统有效干预措施研究”的课题负责单位。
            </div>
                <div class="content2">
                  美奇医疗与中国科学院和浙江大学合作，拥有一支研发管理团队，包括来自全球知名大学和医院的教授、科学家。以现代医学、生物化学、人工智能等高新技术为基础，研发、生产实时动态血糖监测系统。美奇医疗第一代血糖监测系统于2013年在中国发布。公司拥有集研发、生产、销售、服务于一体的完整产业链，拥有完整的自动化生产线，传感器年生产能力达2000万套。
            </div>
                <div class="knowmore" style="background-image: url('static/img/knowmore.png');"
                  @click="changeTabStatus(4)">
                  了解更多>
                </div>
              </div>
              <img src="./assets/img/mg1.png" class="pic1" />
            </div>
            <div style="display: flex;justify-content: space-between;" class="top80">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    2009
                  </div>
                  <div class="title16">
                    年
                  </div>
                </div>
                <div class="title38">
                  美奇医疗成立于
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    57
                  </div>
                  <div class="title16">
                    项
                  </div>
                </div>
                <div class="title38">
                  国内外授权专利
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    16
                  </div>
                  <div class="title16">
                    个
                  </div>
                </div>
                <div class="title38">
                  业务覆盖国家
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    2000+
                  </div>
                  <div class="title16">
                    个
                  </div>
                </div>
                <div class="title38">
                  业务覆盖医院
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    25
                  </div>
                  <div class="title16">
                    万
                  </div>
                </div>
                <div class="title38">
                  全球注册用户
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">F
          <div style="display: flex;width: 100%;height: 100%;background-color: #F8F8F8;">
            <img src="./assets/img/system.png" class="width1212" />

            <div class="width400">
              <div class="title36">
                美奇持续葡萄糖监测系统
              </div>
              <div class="subtitle">
                RGMS
              </div>
              <div class="content141">
                美奇RGMS持续葡萄糖监测系统采用类"血糖Holter"监测模式，实现对患者24小时动态血糖监测。系统通过实时捕捉传统指尖血检测(BGM）难以发现的黎明现象、苏木杰现象及隐匿性高低血糖事件，为临床诊疗决策提供科学依据，助力个性化治疗方案优化，同时为糖尿病研究提供高效科研工具。

              </div>
              <div class="content141">
                系统构成：<br> 生物传感单元、智能终端设备（含专业应用程序）、无线信号传输模块、数据管理分析平台

              </div>
              <div class="content141">
                工作原理： <br>基于皮下组织间液葡萄糖氧化反应原理，通过生物传感器将化学信号转化为电信号，经由智能算法实时处理传输。系统每10秒采集一次数据，每3分钟生成动态血糖值，全天候呈现480组血糖读数，形成可视化血糖图谱，支持多终端实时查看及历史数据追溯。
              </div>
              <div style="background-image: url('static/img/knowmore.png');cursor: pointer;" class="width150"
                @click="changeTabStatus(2)">
                了解更多>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-if="tabStatus == 2">
        <div style="background-image: url('static/img/bg_2.png');width: 100%;background-size: cover; "
          class="height867 padding293">

        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">
          <div style="display: flex;width: 100%;height: 100%;background-color: #F8F8F8;">
            <img src="./assets/img/bg_2_2.png" class="width1212" />

            <div class="width333">
              <div class="title361">
                RGMS持续葡萄糖监测系统
              </div>
              <div class="px311">
                
              </div>
              <div class="xxx1 top36" >
                全天动态追踪，全面血糖数据
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  每3分钟自动记录血糖值，每日生成480个临床级数据点，实时同步App，动态显示血糖曲线与趋势变化。
                </div>
              </div>

              <div class="xxx1 top24">
                智能数据整合，动态管理
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  支持记录饮食、运动和用药，智能生成个性化建议与风险预警，导出结构化报告
                </div>
              </div>

              <div class="xxx1 top24">
                提供血糖分析，临床辅助支持
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  实时血糖趋势、模拟糖化血红蛋白（HbA1c）与平均血糖、餐前/餐后对比、高低血糖事件统计及标准化8点血糖图谱。
                </div>
              </div>

              <div class="top42" style="display: flex;flex-direction: column;">
                <div style="display: flex;flex-direction: row;">
                  <div style="display: flex;flex-direction: row;">
                    <img src="./assets/img/z1.png"  class="zpic"/>
                    <div class="zword">
                      趋势分析
                    </div>
                  </div>

                  <div style="display: flex;flex-direction: row;" class="left80">
                    <img src="./assets/img/z2.png"  class="zpic"/>
                    <div class="zword">
                      餐食影响评估
                    </div>
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top25">
                  <div style="display: flex;flex-direction: row;">
                    <img src="./assets/img/z3.png"  class="zpic"/>
                    <div class="zword">
                      风险预警
                    </div>
                  </div>

                  <div style="display: flex;flex-direction: row;" class="left80">
                    <img src="./assets/img/z4.png"  class="zpic"/>
                    <div class="zword">
                      诊疗方案优化
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">
          <div style="display: flex;width: 100%;height: 100%;background-color: #F8F8F8;">


            <div class="width3331">
              <div class="title361">
                美奇-中央监护系统
              </div>
              <div class="px311">
                智慧监护，动态管理
              </div>
              <div class="xxx1 top36" >
                全院实时监护，数据互联互通
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  护士站集中监测患者动态血糖数据，智能传输实现科室信息化管理，远程监护随时掌握血糖趋势。
                </div>
              </div>

              <div class="xxx1 top24">
                专业报告系统，动态数据支持
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  提供连续动态图谱、TIR等关键指标统计，支持多日血糖对比及临床事件关联分析，基于数据生成个性化建议。
                </div>
              </div>

              <div class="top42" style="display: flex;flex-direction: column;">
                <div style="display: flex;flex-direction: row;">
                  <div style="display: flex;flex-direction: row;">
                    <img src="./assets/img/z5.png"  class="zpic"/>
                    <div class="zword">
                      全院血糖统管
                    </div>
                  </div>

                  <div style="display: flex;flex-direction: row;" class="left80">
                    <img src="./assets/img/z6.png"  class="zpic"/>
                    <div class="zword">
                      指标动态统计
                    </div>
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top25">
                  <div style="display: flex;flex-direction: row;">
                    <img src="./assets/img/z7.png"  class="zpic"/>
                    <div class="zword">
                      异常实时预警
                    </div>
                  </div>

                  <div style="display: flex;flex-direction: row;" class="left80">
                    <img src="./assets/img/z8.png"  class="zpic"/>
                    <div class="zword">
                      提升临床效率
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <img src="./assets/img/bg_2_3.png" class="width1212" />

          </div>
        </div>

        <div
          :style="{ width: '100%', height: fullHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }"
          id="pageFive" ref="pageFive">
          <img src="./assets/img/bg_2_4.png" class="width1478" />
        </div>

        <div
          :style="{ width: '100%', height: fullHeight, display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#F5FAFF' }"
          id="pageFive" ref="pageFive">
          <div class="title36top90">
            无感佩戴，使用简单
          </div>
          <div class="top12title24">
            详细佩戴方法见操作视频
          </div>
          <video src="../static/wear.mp4" class="width1200" controls poster="../static/cover.png" />
        </div>

        <div
          :style="{ width: '100%', height: fullHeight, display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#FFFFFF' }"
          id="pageFive" ref="pageFive">
          <div class="title36top90">
            随时随地，守护如影随形
          </div>
          <div class="top12title24">
            开启轻松测糖新生活，美奇让您做更舒服的自己
          </div>
          <div class="top90">
            <div style="display: flex;align-items: center;flex-direction: column;">
              <img src="./assets/img/bg_2_6.png" class="width354" />
              <div class="things">
                7:00早餐
              </div>
            </div>

            <div style="display: flex;align-items: center;flex-direction: column;" class="left20">
              <img src="./assets/img/bg_2_7.png" class="width354" />
              <div class="things">
                9:00工作
              </div>
            </div>

            <div style="display: flex;align-items: center;flex-direction: column;" class="left20">
              <img src="./assets/img/bg_2_8.png" class="width354" />
              <div class="things">
                19:00运动
              </div>
            </div>

            <div style="display: flex;align-items: center;flex-direction: column;margin-left: 20px;">
              <img src="./assets/img/bg_2_9.png" class="width354" />
              <div class="things">
                22:30睡觉
              </div>
            </div>

          </div>
          <img src="./assets/img/bg_2_10.png" class="height70">
        </div>

        <div :style="{ height: fullHeight }"
          style="background-image: url('static/img/bg_2_15.png');width: 100%;background-size: cover; display: flex;align-items: center;flex-direction: column;"
          class="padding293 top100">
          <div class="px32">
            科技守护健康，关爱零距离
          </div>
          <div class="px33">
            实时同步：监测数据自动上传，家人随时查看最新血糖值；多人管理：支持同时监护多位家庭成员，统一管理更便捷；
跨地域监护：突破时空限制，随时随地掌握家人健康状况
          </div>
        </div>


      </div>

      <div v-if="tabStatus == 3">
        <div class="height867r" id="pageFive">
          <div style="background-image: url('static/img/bg_3_1.png');" class="height472">
            <div class="left221">
              <div>
                <div class="title50">
                  你使用放心，我们努力用心
                </div>
              </div>
              <div class="subtitle24">
                专注健康，值得信赖
              </div>
            </div>
          </div>
          <div class="height400">
            <div class="title36 top60">
              产品购买渠道
            </div>
            <div class="f24t12">
              官方指定平台
            </div>
            <div style="display: flex;" class="top48">
              <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
                class="width392">
                <div class="f24">
                  淘宝官方旗舰店>
                </div>
                <div class="f16">
                  美奇医疗器械旗舰店
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;
              " class="width392 left28">
                <div class="f24">
                  京东官方旗舰店>
                </div>
                <div class="f16">
                  美奇医疗器械旗舰店
                </div>
              </div>
            </div>


          </div>
        </div>


        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">
          <div style="display: flex;align-items: center;flex-direction: column;width: 100%;"
            :style="{ height: fullHeight }">
            <div class="f36t130">
              软件下载
            </div>
            <div class="f24t12">
              在各大手机应用市场搜索对应APP名称即可下载
            </div>
            <div style="display: flex;" class="top48">

            </div>
            <div style="display: flex;">
              <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="./assets/img/bg_3_2.png" class="height393" />
                <div class="f24t16">
                  美奇
                </div>
                <div class="f16t8">
                  主推版-监测版，功能全面
                </div>
              </div>

              <div
                style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 28px;">
                <img src="./assets/img/bg_3_3.png" class="height393" />
                <div class="f24t16">
                  美奇极速版
                </div>
                <div class="f16t8">
                  专为长辈设计大字版，阅读轻松、简单好用
                </div>
              </div>

              <div
                style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 28px;">
                <img src="./assets/img/bg_3_4.png" class="height393" />
                <div class="f24t16">
                  美奇医生端
                </div>
                <div class="f16t8">
                  患者管理、医患沟通
                </div>
              </div>
            </div>


          </div>
        </div>

        <div id="pageFive" ref="pageFive" :style="{ height: fullHeight }"
          style="display: flex;flex-direction: column;align-items: center;width: 100%;background-color:#F5FAFF;">
          <div style="display: flex;align-items: center;flex-direction: column;width: 100%;"
            :style="{ height: fullHeight }">
            <div class="f36t130">
              售后服务
            </div>
            <div class="f24t12">
              与我们联系
            </div>
            <div style="display: flex;flex-direction: column;" class="top48">
              <div style="display: flex;flex-direction: row;">
                <div class="unknow">
                  <img src="./assets/img/bg_3_10.png" class="t36h82w82" />
                  <div class="f24t18">
                    客服热线
                  </div>
                  <div class="f16t8">
                    400-0572-278
                  </div>
                </div>

                <div class="unknow left28">
                  <img src="./assets/img/bg_3_11.png" class="t36h82w82" />
                  <div class="f24t18">
                    地址
                  </div>
                  <div class="f16t8">
                    浙江省湖州市南太湖生物医药产业园
                  </div>
                  <div class="f16">
                    瑶池路58号5号楼
                  </div>
                </div>

                <div class="unknow left28">
                  <img src="./assets/img/bg_3_12.png" class="t36h82w82" />
                  <div class="f24t18">
                    商务对接
                  </div>
                  <div class="f16t8">
                    电话: 13567983061
                  </div>
                  <div class="f16">
                    邮箱：lym@mqcgm.com
                  </div>
                </div>
              </div>

              <div style="display: flex;flex-direction: row;" class="top28">
                <div class="unknow2">
                  <img src="./assets/img/bg_3_14.png" class="px1" />
                  <div class="px2">
                    扫码关注美奇公众号，享快速便捷服务
                  </div>
                  <img src="./assets/img/bg_3_15.png" class="px3" />
                </div>
              </div>
            </div>


          </div>
        </div>

        <div id="pageFive" ref="pageFive" class="px4" :style="{ height: fullHeight }">
          <div>
            <div class="f36">
              常见问题FQA
            </div>
          </div>
          <a-input class="px7" placeholder="搜索关键词" v-model="sParams.question" @keydown.enter="getList">
            <a-icon slot="prefix" type="search" />
          </a-input>

          <a-collapse accordion class="px8" :expand-icon-position="expandIconPosition" :bordered="false">
            <a-collapse-panel :key="index" :header="item.question" v-for="(item, index) in QAList" :style="customStyle">
              <p class="px9">{{ item.solution }}</p>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>

      <div v-if="tabStatus == 4">
        <div style="background-image: url('static/img/bg_4_1_1.png');" class="px10">
          <div>
            <div class="px11">
              专注血糖动态监测数据管理
            </div>
          </div>
          <div class="px12">
            致力于糖尿病患者健康事业，专注品质、关怀健康
          </div>
        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex' }" id="pageFive" ref="pageFive">
          <div
            style="display: flex;width: 100%;height: 100%;background-color: #FFFFFF;flex-direction: column;align-items: center;">



            <div class="f36 top76">
              湖州美奇医疗器械有限公司
            </div>

            <div class="content12">
              湖州美奇医疗器械有限公司成立于2009年9月，总部位于浙江湖州，已获国家级高新技术企业和中国浙江省高新技术企业研究开发中心。是国家重点研发项目“糖脂代谢异常亚健康状态预警及系统有效干预措施研究”的课题负责单位。
            </div>
            <div class="content12">
              美奇医疗与中国科学院和浙江大学合作，拥有一支研发管理团队，包括来自全球知名大学和医院的教授、科学家。以现代医学、生物化学、人工智能等高新技术为基础，研发、生产实时动态血糖监测系统。美奇医疗第一代血糖监测系统于2013年在中国发布。公司拥有集研发、生产、销售、服务于一体的完整产业链，拥有完整的自动化生产线，传感器年生产能力达2000万套。公司秉承“质量第一，关爱健康”的企业目标，为用户的健康保驾护航。

            <img src="./assets/img/bg_4_2_3.png" class="top20" />

            <div style="display: flex;" class="top66">
              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c1.png" class="c1" />
                <div class="c2">
                  企业愿景
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  成为中国实时动态血糖智能监测产业的领导者
                </div>
              </div>

              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c2.png" class="c1" />
                <div class="c2">
                  企业使命
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  致力于糖尿病患者健康事业
                </div>
              </div>

              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c3.png" class="c1" />
                <div class="c2">
                  企业价值观
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  诚信立足、创新致远
                </div>
              </div>

              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c4.png" class="c1" />
                <div class="c2">
                  企业宗旨
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  专注品质，关怀健康
                </div>
              </div>
            </div>

          </div>
        </div>

        </div>

        <div id="pageFive" ref="pageFive" :style="{ height: fullHeight }"
          style="background-image: url('static/img/bg_4_3.png');" class="px14">
          <div class="px15">
            发展历程
          </div>
        </div>

        <div id="pageFive" ref="pageFive" class="px26" :style="{ height: fullHeight }">
          <div>
            <div class="f361">
              资质荣誉
            </div>
          </div>
          <div class="px27">
            【技术创新实力】作为国家级高新技术企业及省级专精特新企业，我们构建了覆盖全产业链的自主知识产权体系。在核心技术领域累计申请发明专利29项（已获授权13项）、实用新型专利41项（已授权32项）、外观设计专利13项（已授权12项），并持有40项软件著作权证书，形成多维立体的技术资产组合。【体系化保护】通过"产品+工艺+算法"三位一体的知识产权战略布局，我们已搭建起覆盖全链条技术节点的专利护城河，有效实现核心技术资产的全生命周期保护，为产品创新构筑坚实的技术壁垒。
          </div>

          <div style="display: flex;justify-content: space-between;" class="top20 width1348">

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  13
                </div>
                <div class="title16">
                  项
                </div>
              </div>
              <div class="title381">
                发明专利-已授权
              </div>
            </div>

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  32
                </div>
                <div class="title16">
                  项
                </div>
              </div>
              <div class="title381">
                实用新型专利-已授权
              </div>
            </div>

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  12
                </div>
                <div class="title16">
                  项
                </div>
              </div>
              <div class="title381">
                外观设计专利-已授权
              </div>
            </div>

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  40
                </div>
                <div class="title16">
                  项
                </div>
              </div>
              <div class="title381">
                软件著作权-已授权
              </div>
            </div>
          </div>

          <img src="./assets/img/c5.png" class="c5" />
        </div>
        
        

        <div id="pageFive" ref="pageFive" :style="{ height: fullHeight }" class="px29">
          <div class="container">
            <div style="display: flex;" :style="{ height: fullHeight3 }">
              <img src="./assets/img/1.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/2.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/3.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/4.png" class="pic2 pc2 trans2" />
            </div>
            <div style="display: flex;" :style="{ height: fullHeight3 }">
              <img src="./assets/img/5.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/6.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/7.png" class="pic22 pc2 trans2" />
            </div>
            <div style="display: flex;" :style="{ height: fullHeight3 }">
              <img src="./assets/img/9.png" class="pic2 pc3 trans3" />
              <img src="./assets/img/10.png" class="pic2 pc3 trans3" />
              <img src="./assets/img/11.png" class="pic2 pc3 trans3" />
              <img src="./assets/img/12.png" class="pic2 pc4 trans4" />
            </div>
          </div>
        </div>
      </div>


      <div class="bottom-black" id="pageFour" ref="pageFour">
        <div class="bottom-ori">
          <img src="./assets/mq_logo.png" class="bottom-logo">
          <div class="bottom-margin-left bottom-word">
            <div style="cursor: pointer;" @click="changeTabStatus(1)">
              首页
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="changeTabStatus(2)">
              产品及解决方案
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="changeTabStatus(3)">
              服务与支持
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="changeTabStatus(4)">
              关于美奇
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="showReport()">
              会员中心
            </div>
          </div>

          <div class="bottom-word1">
            <div>
              联系我们
            </div>
            <div class="bottom-margin-top bottom-qrcode-word">
              地址：浙江省湖州市南太湖生物医药产业园瑶池路58号5号楼
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              电话：400-0572-278
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              邮编：313000
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              手机号码：13567983061
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              邮箱：lym@mqcgm.com
            </div>
          </div>
        </div>
        <div class="bottom-ori icp-copyright left50" style="margin-top: 30px;">

          <div style="">
            <div style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img src="./assets/img/0.png" style="float:left;" />
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#ffffff;">
                浙公网安备 33059102000319号
              </p>
            </div>
          </div>

          <a href="https://beian.miit.gov.cn/#/Integrated/index" class="bottom-qrcode-word"
            style="margin-left:197px;color:#ffffff;opacity: 1">浙ICP备16013812号</a>

        </div>
        <div class="icp-copyright" style="bottom:20px;color:white;left: 43%;">Copyright ©2017 湖州美奇医疗器械有限公司</div>
        <img src="./assets/img/totop.png"
          style="width: 66px;height: 66px;margin-left: 272px;margin-top: 234px;cursor: pointer;" @click="goTop" />
      </div>
    </div>
  </div>
</template>
<script>




import Login from './view/Login'

import Vue from 'vue'
import { ACCESS_TOKEN } from './store/mutation-types'
import PDFModal from './components/PDFModal'
import { getAction } from './network/GetAndPost'

export default {
  name: 'MainPage',
  components: [Login, PDFModal],
  data() {
    return {
      customStyle: 'background: #ffffff',
      calcuHeight: '',
      sParams: {},
      qaurl: 'faq/list',
      QAList: [],
      expandIconPosition: 'right',
      swiperOptions: {
        slidesPerView: 1, // 显示个数
        direction: 'horizontal',
        loop: true,
        // 启用分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }
      },
      menuStyle: {
        position: 'absolute',
        top: '0px',
        zIndex: 3,
        right: '0px',
        width: '438px',
        height: '100%',
        backgroundColor: 'white',
        display: 'none'
      },
      menuStyle1: {
        width: '325px',
        height: '100%',
        display: 'block',
        paddingLeft: '130px'
      },
      tStyle: {
        height: '100px',
        width: '500px',
        background: '#FF0000'
      },
      menu: {
        title: '首頁',
        children: [
          {
            title: `Today's Deals`,
            link: `/today`,
            children: []
          },
          {
            title: `Shop By Department`,
            children: [
              {
                title: `Amazon Music`,
                link: `/music`,
                children: []
              },
              {
                title: `CDs and Vinyl`,
                link: `/cds`,
                children: []
              }
            ]
          }
        ]
      },
      pageStatus: 1,
      readyStatus: 1,
      tabStatus: 1,
      aboutUsArray: ["关于我们", "发展历程", "企业文化", "资质荣耀", "关于团队", "销售渠道"],
      productArray: ["产品配件", "功能介绍", "产品优势", "佩戴流程", "监护系统"],
      downloadArray: ["美奇用户端", "美奇医生端"],
      menus: []
    }
  },
  computed: {
    fullHeight() {
      return window.innerHeight + 'px'
    },

    fullHeight3() {
      return window.innerHeight / 3 + 'px'
    },
  },
  methods: {
    isSelect(n) {
      if (n == this.tabStatus) {
        return true
      } else {
        return false
      }
    },
    isUnSelect(n) {
      if (n == this.tabStatus) {
        return false
      } else {
        return true
      }
    },
    getList() {
      getAction("https://manage.mqcgm.com/jeecg-boot/faq/list", this.sParams).then((res) => {
        if (res.success) {
          this.QAList = res.result.records
        }
      })
    },
    changeTabStatus(ts) {

      this.goTop()

      this.tabStatus = ts


    },
    goTop() {
      this.pageStatus = 1
      // 获取当前位置
      let c = window.pageYOffset
      // 计算滚动距离
      // 开滚
      this.scrollAnimation(c, 0)
    },
    selectColor(pos) {
      if (pos === 1) {

      } else if (pos === 2) {

      } else if (pos === 4) {

      }
    },
    showReport() {
      let a = Vue.ls.get(ACCESS_TOKEN)
      if (a === "" || a === null || a === undefined) {
        this.$router.push({ name: 'Login' })
      } else {
        this.$router.push({ name: 'personalMain' })
      }
    },
    showMenu() {
      this.menuStyle.display = 'block'
    },
    closeMenu() {
      this.menuStyle.display = 'none'
    },
    windowAddMouseWheel() {
      window.addEventListener('wheel', this.throttle((e) => {
        // 直接传递滚动量（禁用防抖）
        window.scrollBy(0, e.deltaY / 3)
      }, 0), { passive: true })
    },
    throttle(func, delay) {
      let timer = null;
      return function () {
        if (!timer) {
          func.apply(this, arguments);
          timer = setTimeout(() => {
            timer = null;
          }, delay);
        }
      };
    },
    /**
     * 单击事件自动向上或向下滚动一屏
     */
    pagingDown() {
      // 获取窗口高度
      let h = window.innerHeight

      let temp = 4;
      if (this.tabStatus == 1) {
        temp = 4
      } else if (this.tabStatus == 2) {
        temp = 8
      } else if (this.tabStatus == 3) {
        temp = 5
      } else if (this.tabStatus == 4) {
        temp = 7
      }
      if (this.pageStatus !== temp) {
        h = window.innerHeight
      } else {
        h = document.getElementById("pageFour").offsetHeight
      }
      if (this.pageStatus !== temp) {
        this.pageStatus = this.pageStatus + 1
      }

      // 获取当前位置
      let c = window.pageYOffset
      // 计算滚动距离
      // 开滚

      console.log("c is" + c);
      console.log("h is" + h);
      this.scrollAnimation(c, c + h)
    },
    pagingUp() {
      // 获取窗口高度
      let h = window.innerHeight
      let temp = 4;
      if (this.tabStatus == 1) {
        temp = 4
      } else if (this.tabStatus == 2) {
        temp = 8
      } else if (this.tabStatus == 3) {
        temp = 5
      } else if (this.tabStatus == 4) {
        temp = 7
      }
      if (this.pageStatus !== temp) {
        h = window.innerHeight
      } else {
        h = document.getElementById("pageFour").offsetHeight
      }
      if (this.pageStatus !== 1) {
        this.pageStatus = this.pageStatus - 1
      }
      // 获取当前位置
      let c = window.pageYOffset
      // 计算滚动距离
      // 开滚
      console.log("c is" + c);
      console.log("h is" + h);
      this.scrollAnimation(c, c - h)
    },
    /**
     * 动画垂直滚动到页面指定位置
     * @param { Number } currentY 当前位置
     * @param { Number } targetY 目标位置
     */
    scrollAnimation(currentY, targetY) {
      // 获取当前位置方法
      const duration = 1000
      const startTime = Date.now()

      const animate = () => {
        const progress = Math.min((Date.now() - startTime) / duration, 1)
        window.scrollTo(0, currentY + (targetY - currentY) * progress)
        if (progress < 1) requestAnimationFrame(animate)
      }
      requestAnimationFrame(animate)
    },
    changeQRCode(param) {
      if (param === 1) {
        this.download = Download
      } else if (param === 2) {
        this.download = Docker
      }
    }
  },
  mounted() {
    // console.log(this.swiper)
    this.windowAddMouseWheel()
    this.getList()

    this.calcuHeight = window.innerHeight - this.$refs.pnavigation.offsetHeight + 'px'
  }
}
</script>

<style scoped>
#app {
  height: auto;
  /* 改为自适应高度 */
  overflow-y: visible;
  /* 启用原生滚动 */
  scroll-behavior: smooth;

  /* 启用GPU加速 */
}

.zs {
  margin-top: 50px;
  color: #FFFFFF;
  font-size: 26px;
}

.menuStyle1 {
  width: 455px;
  height: 100%;
  display: block;
  padding-left: 130px
}

.bottom-top {
  margin-top: 132px;
}

.bottom-margin-left-1 {
  margin-left: 30px;
}

.bottom-margin-left {
  margin-left: 205px;
}

.bottom-qrcode-download {
  font-size: 16px;
  font-weight: 350;
  color: #FFFFFF;
  line-height: 22px;
}

.bottom-qrcode-word {
  font-size: 12px;
  font-weight: 350;
  color: #FFFFFF;
  line-height: 17px;
  opacity: 0.6;
}

.bottom-qrcode {
  width: 95px;
  height: 95px;
}

.bottom-margin-top {
  margin-top: 30px;
}

.bottom-margin-top-2 {
  margin-top: 20px;
}

.bottom-word {
  font-size: 16px;
  font-weight: 350;
  color: #FFFFFF;
  margin-left: 205px;
  margin-top: 132px;
}

.bottom-word1 {
  font-size: 16px;
  font-weight: 350;
  color: #FFFFFF;
  margin-left: 271px;
  margin-top: 132px;
}

.bottom-ori {
  display: flex;
  flex-direction: row;
}

.icp-copyright {
  bottom: 50px;
  position: absolute;
}

.left50 {
  left: 34%
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  overflow-y: hidden;
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.bottom-black {
  width: 100%;
  height: 483px;
  display: flex;
  position: relative;
  background: #1D1E24
}

.vip-center {
  padding: 7px 14px;
  width: fit-content;
  height: fit-content;
  background: #212121;
  border-radius: 19px;
  display: flex;
  align-items: center;
  position: absolute;
  right: 195px;
}

.go-english {
  padding: 7px 14px;
  width: fit-content;
  height: fit-content;
  background: #212121;
  border-radius: 19px;
  display: flex;
  align-items: center;
  position: absolute;
  right: 340px;
}

.vip-word {
  cursor: pointer;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
}

.vip-word-1 {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
}

.img_bg {
  width: 100%;
  height: 100%;
}

.img_bg1 {
  width: 435px;
  height: 500px;
}

.title {
  position: absolute;
  top: 40px;
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
}



.logo {
  position: absolute;
  top: 0px;
  left: 130px;
  width: 231px;
  height: 36px;
}

.bottom-logo {
  margin-top: 127px;
  margin-left: 221px;
  width: 231px;
  height: 36px;
}

.menu {
  position: absolute;
  right: 129px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.center-text {
  top: 280px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-name {
  width: 188px;
  height: 79px;
}

.center-slogan {
  margin-top: 33px;
  font-size: 30px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 42px;
}

.center-button-layout {
  margin-top: 110px;
}

.center-button-left {
  width: 189px;
  height: 62px;
  cursor: pointer;
}

.center-button-right {
  width: 189px;
  height: 62px;
  margin-left: 40px;
  cursor: pointer;
}

.next_page_arrow {
  position: absolute;
  width: 34px;
  height: 34px;
  left: 50%;
  transform: translate(-50%);
  bottom: 60px;
  cursor: pointer;
}

.temp_word {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 250px;
  cursor: pointer;
  font-size: 20px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 42px;
}

.remark_number {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 60px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 42px;
}

.page_title {
  margin-top: 106px;
  font-size: 40px;
  font-weight: 500;
  color: #333333;
  line-height: 56px;
}

.page_sub_title {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  line-height: 22px;
  text-decoration: none;
}

.right-title {
  margin-bottom: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #666666;
  line-height: 25px;
  cursor: pointer;
}

.active {
  color: #009CEE
}

.pnavigation {
  height: 78px;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.plogo {
  margin-left: 223px;
  height: 30px;
  width: 180px;
}

.pswiper {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.selectTitle {
  font-weight: 600;
  font-size: 16px;
  color: #009CEE;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}

.unSelectTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}

.marginLeft240 {
  margin-left: 240px;
}

.marginLeft68 {
  margin-left: 68px;
}

.height867 {
  height: 867px
}

.icon123 {
  height: 64px;
  width: 64px;
  position: absolute;
  bottom: 86px;
  left: 221px;
  cursor: pointer;
}

.padding1 {
  padding: 127px 221px 92px 221px
}

.width534 {
  width: 614px;
}

.title36 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.subtitle {
  font-weight: 500;
  font-size: 36px;
  color: #009CEE;
}

.content1 {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  margin-top: 30px;
  line-height: 28px;
}

.content12 {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  width: 1478px;
  margin-top: 16px;
}

.content2 {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  margin-top: 18px;
  line-height: 28px;
}

.knowmore {
  cursor: pointer;
  width: 150px;
  height: 54px;
  background-size: cover;
  margin-top: 30px;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;

}

.pic1 {
  height: 572px;
  width: 824px;
  margin-left: 40px;
}

.title72 {
  font-weight: 500;
  font-size: 52px;
  color: #333333;
  line-height: 1;
}

.title721 {
  font-weight: 500;
  font-size: 52px;
  color: #333333;
  line-height: 40px;
}

.title52 {
  font-weight: 500;
  font-size: 72px;
  color: #333333;
  line-height: 1;
}

.title16 {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

.title38 {
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  margin-top: 36px;
}

.title381 {
  font-weight: 350;
  font-size: 16px;
  color: #333333;
  margin-top: 16px;
}

.width1212 {
  width: 1212px;
  height: 100%;
}

.top20 {
  width: 1478px;

  margin-top: 20px;
}

.top66 {
  width: 1478px;
  margin-top: 26px;
  justify-content: space-between;
}

.c1 {
  width: 40px;
  height: 40px;
}

.c2 {
  color: #333333;
  font-size: 18px;
}

.c3 {
  color: #999999;
  font-size: 16px;
}

.c5 {
  margin-top: 32px;
  width: 1348px;
  height: 574px;
}

.width333 {
  width: 430px;
  margin-top: 147px;
  margin-left: 50px;
}

.width3331{
  width: 430px;
  margin-top: 243px;
  margin-left: 221px;
  margin-right: 87px;
}

.width400 {
  width: 400px;
  margin-top: 170px;
  margin-left: 154px;
}

.content14 {
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  margin-top: 30px;
  line-height: 28px;
}

.content141 {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  margin-top: 30px;
  line-height: 28px;
}

.width150 {
  width: 150px;
  height: 54px;
  background-size: cover;
  margin-top: 30px;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.padding293 {
  padding-top: 293px;
}

.width453 {
  margin-left: 221px;
  width: 453px;
}

.title50 {
  font-weight: 500;
  font-size: 50px;
  color: #333333;
  line-height: 68px;
}

.subtitle22 {
  font-weight: 350;
  font-size: 22px;
  color: #333333;
  margin-top: 17px;
  line-height: 28px;
}

.content18 {
  font-weight: 350;
  font-size: 18px;
  color: #666666;
  margin-top: 0px;
  line-height: 28px;
}

.content22 {
  font-weight: 350;
  font-size: 22px;
  color: #333333;
  margin-top: 17px;
  line-height: 28px;
}

.width334 {
  width: 334px;
  margin-top: 170px;
  margin-left: 221px;
  margin-right: 154px;
}

.subtitle16 {
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.width1478 {
  width: 1478px;
  height: 807px
}

.title36top90 {
  margin-top: 90px;
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.title361 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  line-height: 50px;
}

.top12title24 {
  margin-top: 12px;
  font-weight: 350;
  font-size: 24px;
  color: #333333;
}

.width1200 {
  width: 1200px;
  height: 675px;
  margin-top: 40px;
}

.top90 {
  display: flex;
  margin-top: 90px;
}

.width354 {
  height: 354px;
  width: 354px;
}

.things {
  font-weight: 500;
  font-size: 24px;
  color: #333333;
  margin-top: 40px;
}

.left20 {
  margin-left: 20px;
}

.height70 {
  width: 100%;
  height: 70px;
  margin-top: 36px;
}

.height867r {
  width: 100%, ;
  height: 867px;
  position: relative
}

.height472 {
  height: 472px;
  width: 100%;
  background-size: cover;
  padding-top: 177px;
  display: flex;
  flex-direction: column;
}

.left221 {
  margin-left: 221px;
}

.subtitle24 {
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  margin-top: 20px;
  line-height: 28px;
}

.height400 {
  height: 400px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.f24t12 {
  font-weight: 350;
  font-size: 24px;
  color: #333333;
  margin-top: 12px;
}

.top48 {
  margin-top: 48px;
}

.width392 {
  width: 392px;
  height: 154px;
  background: #D7E7FF;
  border-radius: 16px;
}

.f24 {
  font-weight: 350;
  font-size: 24px;
  color: #333333;
}

.f16 {
  font-weight: 350;
  font-size: 16px;
  color: #333333;
}

.f36t130 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  margin-top: 130px;
}

.height393 {
  height: 393px;
  width: 479px;
}

.f24t16 {
  font-weight: 350;
  font-size: 24px;
  color: #333333;
  margin-top: 16px;
}

.f16t8 {
  font-weight: 350;
  font-size: 16px;
  color: #333333;
  margin-top: 8px;
}

.unknow {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 392px;
  height: 290px;
  background: #D7E7FF;
  border-radius: 16px;
}

.unknow1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 392px;
  height: 219px;
  background: #D7E7FF;
  border-radius: 16px;
}

.unknow2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 219px;
  background: #D7E7FF;
  border-radius: 16px;
}

.t36h82w82 {
  margin-top: 36px;
  width: 82px;
  height: 82px;
}

.f24t18 {
  font-weight: 350;
  font-size: 24px;
  color: #333333;
  margin-top: 18px;
}

.left28 {
  margin-left: 28px;
}

.px1 {
  width: 82px;
  height: 82px;
  margin-left: 155px;
}

.px2 {
  font-weight: 350;
  font-size: 24px;
  color: #333333;
  line-height: 33px;
  margin-left: 30px;
}

.px3 {
  width: 162px;
  height: 162px;
  margin-left: 120px;
}

.px4 {
  width: 100%;
  background-size: cover;
  padding-top: 82px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.f36 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  line-height: 68px;
}

.f361 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  line-height: 50px;
}

.top76 {
  margin-top: 90px;
}

.px5 {
  width: 860px;
  height: 58px;
  border-radius: 43px;
  background-color: #F5FAFF;
  font-weight: 350;
  font-size: 16px;
  color: #999999;
  display: flex;
  align-items: center;
}

.px6 {
  width: 20px;
  height: 20px;
  margin-left: 25px;
}

.px7 {
  width: 860px;

  font-weight: 350;
  font-size: 16px;
  color: #333333;
  border: none;
  margin-right: 30px;
  margin-left: 10px;
}

.px8 {
  margin-top: 75px;
  width: 1478px;
}

.px9 {
  font-weight: 350;
  font-size: 16px;
  color: #009CEE;
}

.px10 {
  height: 867px;
  width: 100%;
  background-size: cover;
  padding-top: 82px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.px11 {
  font-weight: 500;
  font-size: 50px;
  color: #333333;
  line-height: 68px;
}

.px12 {
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  margin-top: 20px;
  line-height: 28px;
}

.px13 {

  margin-top: 76px;
}

.top38 {
  margin-top: 38px;
}

.px14 {
  background-size: cover;
  padding-top: 118px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.px15 {
  color: #333333;
  font-size: 30px;
  font-weight: 600;
}

.px16 {
  margin-left: 1143px;
  padding: 73px 61px 73px 61px;
  width: 460px;
  border-radius: 20px;
  background-color: #FFFFFF;
}

.px17 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.px18 {
  margin-top: 30px;
  font-size: 16px;
  color: #333333;
}

.px19 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px20 {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
}

.px21 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px22 {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
}

.px23 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px24 {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
}

.px25 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px26 {
  width: 100%;
  background-size: cover;
  padding-top: 82px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.px261 {
  width: 100%;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.px27 {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  margin-top: 18px;
  line-height: 22px;
  width: 1348px;
  text-align: center;
}

.width1348 {
  width: 1348px;
}

.px28 {
  width: 1400px;
  margin-top: 40px;
  margin-bottom: 50px;
}

.height500 {
  height: 500px;
}

.px29 {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.px30 {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  margin-top: 20px;
  line-height: 28px;
  width: 1202px;
}

.top60 {
  margin-top: 60px;
}

.top28 {
  margin-top: 28px;
}

.px31 {
  font-weight: 500;
  font-size: 36px;
  color: #009CEE;
}

.px311 {
  font-weight: 500;
  font-size: 28px;
  color: #009CEE;
  line-height: 40px;
}

.top100 {
  padding-top: 100px;
}

.px32 {
  font-weight: 500;
  font-size: 36px;
  color: #FFFFFF;
}

.px33 {
  margin-top: 12px;
  width: 1270px;
  height: 66px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 350;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 33px;
  text-align: center;
}

.left60 {
  margin-left: 60px;
}

.swiper-pagination {
  position: absolute;
  bottom: 60px;
}

.top80 {
  margin-top: 80px;
}

.pic2 {
  flex: 1;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease-in-out;
  /* 新增过渡效果 */
}

.pic22 {
  flex: 2;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease-in-out;
  /* 新增过渡效果 */
}

.trans1 {
  transform-origin: 0 0;
}

.trans2 {
  transform-origin: 100% 0;
}

.trans3 {
  transform-origin: 0 100%;
}

.trans4 {
  transform-origin: 100% 100%;
}

/* 图片悬停时的样式 */
.pc1:hover {
  transform: scale(2);
  transform-origin: 0 0;
  /* 保持原有代码不变 */
}

/* 图片悬停时的样式 */
.pc2:hover {
  transform: scale(2);
  transform-origin: 100% 0;
  /* 保持原有代码不变 */
}

/* 图片悬停时的样式 */
.pc3:hover {
  transform: scale(2);
  transform-origin: 0 100%;
  /* 保持原有代码不变 */
}

/* 图片悬停时的样式 */
.pc4:hover {
  transform: scale(2);
  transform-origin: 100% 100%;
  /* 保持原有代码不变 */
}

.xxx1 {
  font-weight: 500;
  font-size: 22px;
  color: #333333;
  line-height: 31px;
}

.top36{
  margin-top: 36px;
}

.top24{
  margin-top: 24px;
}

.xxx2{
  margin-top: 6px;
}

.xxx3{
  font-weight: 400;
font-size: 18px;
color: #666666;
line-height: 31px;
margin-left: 4px;
}

.point {
  width: 8px;
  height: 8px;
  background: #009CEE;
  opacity: 0.8;
  margin-top: 10px;
  border-radius: 8px;
}

.top42{
  margin-top: 42px;
}

.top25{
  margin-top: 25px;
}

.zpic{
  width: 30px;
  height: 30px;
}

.zword{
  font-weight: 500;
font-size: 20px;
color: #333333;
line-height: 28px;
margin-left: 6px;
}

.left80{
  margin-left: 80px;
}

</style> 








<!-- <template>
  <div id="app">
    <div>
      
    </div>
  </div>
</template> -->


// WEBPACK FOOTER //
// src/MainPage.vue